module.exports = __webpack_public_path__ + "img/clothing34.b399fc91.jpg";